/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {computeChangeToBalances} from '../api'

export const useMutationComputeChangeToBalances = createReactQueryMutationHook('computeChangeToBalances', computeChangeToBalances)
